var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluePlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 612 612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00abf9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "blue plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_8",
    "data-name": 8
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306,0C137,0,0,137,0,306S137,612,306,612,612,475,612,306,475,0,306,0Zm0,573.75C158.13,573.75,38.25,453.88,38.25,306S158.13,38.25,306,38.25,573.75,158.13,573.75,306,453.88,573.75,306,573.75ZM420.75,286.88H325.13V191.25a19.13,19.13,0,0,0-38.25,0v95.63H191.25a19.13,19.13,0,0,0,0,38.25h95.63v95.62a19.13,19.13,0,1,0,38.25,0V325.13h95.62a19.13,19.13,0,1,0,0-38.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePlus);
export default __webpack_public_path__ + "static/media/blue-plus.2a07dac0e0fb3f3e1eb29a8ce5816c77.svg";
export { ForwardRef as ReactComponent };